<template>
  <div class="wrapper-content w-100">
    <h1>{{title}}</h1>
    <LmBreadcrumb />
    <LmForm ref="lmForm">
      <LmTextInput
        v-model="form.name"
        :v="$v.form.name"
        label="name"
        placeholder="name"
      />
      <LmTextArea
        id="mjml-template"
        v-model="form.template"
        :v="$v.form.template"
        rows="11"
        :maxLength="20000"
        label="MJML Template"
        :placeholder="`
  <mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>
        `.trim()"
      />
      <LmSelect
        v-model="form.published"
        :v="$v.form.published"
        :options="optionsPublish"
        label="Publicado"
        />
      <LmButton type="button" value="Previsualizar template" @click.native="preview()"/>
      <div class="row">
        <div class="col-12">
          <LmButton
            type="button"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
          />
          <LmButton
            type="button"
            :value="$t('Save')"
            :isProcessing="isFormProcessing"
            @click.native="submit()"
            buttonClass="btn-primary"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
          />
        </div>
      </div>
    </LmForm>
    <LmTemplatePreviewModal ref="lmTemplatePreviewModal"/>
  </div>
</template>

<script>
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmTemplatePreviewModal from '@/components/modals/LmTemplatePreviewModal'

import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
export default {
  data () {
    return {
      optionsPublish: {
        content: [{ value: true, text: 'Si' }, { value: false, text: 'No' }]
      },
      form: {
        name: '',
        template: `<mjml>
    <mj-body>
      <mj-section>
        <mj-column>
          <mj-text>
            Hello World!
          </mj-text>
        </mj-column>
      </mj-section>
    </mj-body>
  </mjml>`,
        type: 'email',
        published: false
      },
      isFormProcessing: false,
      initialForm: {}
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmTextArea,
    LmSelect,
    LmButton,
    LmTemplatePreviewModal
  },
  validations: {
    form: {
      name: {
        required
      },
      published: {
        required
      },
      template: {
        required
      }
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    onSuccessDestinationRoute: {
      type: String,
      required: true,
      default: '/templates/listado'
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    isOnEditMode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async setForm () {
      if (this.isOnEditMode) {
        this.$refs.lmForm.activeEditMode({
          path: 'templates/email/read/',
          id: this.$route.params.id
        })
          .catch(error => {
            console.log(error)
            this.$router.replace({ name: '404' })
          })
      } else {
        this.form = JSON.parse(this.initialForm)
      }
    },
    cancelBtn () {
      if (this.$v.form.$invalid) {
        this.$router.push(this.onSuccessDestinationRoute)
      } else {
        if (confirm(this.$t('cancel_msg'))) {
          this.$router.push(this.onSuccessDestinationRoute)
        }
      }
    },
    async preview () {
      await this.$refs.lmForm.validationForm(this.$v)
      try {
        const previewData = {
          name: this.form.name,
          template: this.form.template.trim(),
          type: this.form.type,
          preview: true,
          published: this.form.published
        }
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}templates/new/`,
          previewData
        )
        const template = JSON.parse(response.data.template).html
        this.$refs.lmTemplatePreviewModal.openEmailPreviewModal(template)
      } catch (error) {
        console.log(error)
      }
    },
    async submit () {
      try {
        this.isFormProcessing = true
        await this.$refs.lmForm.validationForm(this.$v)
        const dataToSendToTheServer = {
          name: this.form.name,
          template: this.form.template.trim(),
          type: this.form.type,
          preview: false,
          published: this.form.published,
          isOnEditMode: this.isOnEditMode,
          id: this.form.id
        }
        await axios.post(
          `${process.env.VUE_APP_API_URL}templates/new/`,
          dataToSendToTheServer
        )
        this.$router.push(this.onSuccessDestinationRoute)
      } catch (error) {
        console.log(error)
      } finally {
        this.isFormProcessing = false
      }
    }
  },
  created () {
    this.initialForm = JSON.stringify(this.form)
  },
  mounted () {
    this.setForm()
  }
}
</script>
